<template>
  <div>
    <div v-if="cliente.id">
      <b-card class="mb-3">
        <h4>Definir parceiro</h4>
        <div class="d-flex mb- flex-column">
          <div class="w-100 mr-auto">
            <b-form-group label="Parceiro:">
              <SelectParceiro v-model="cliente.parceiro_id" />
            </b-form-group>
          </div>
        </div>
      </b-card>
      <b-card v-if="showPagamentosTable">
        <h4>Assinaturas e Histórico de pagamento</h4>
        <div class="d-flex flex-row align-items-center pb-2">
          <h5 class="h5 text-uppercase tracking-widest text-gray mb-0 mr-auto">
            Assinaturas
          </h5>
          <b-button size="sm" variant="exitos" @click="novaAssinatura">
            Nova Assinatura
          </b-button>
        </div>
        <b-table
          hover
          striped
          show-empty
          sort-by="updated_at"
          :fields="headers"
          :items="clientePlanos"
        >
          <template #cell(plano_exitos.nome)="{ value, item }">
            <div class="d-inline">
              {{ value }}
              <b-badge
                v-if="!!item?.teste_gratis"
                pill
                class="ml-2 px-2 bg-exitos text-white"
              >
                Teste grátis
              </b-badge>
            </div>
          </template>
          <template #cell(status)="{ value }">
            <font-awesome-icon
              v-if="value"
              :icon="value"
              class="text-success"
            />
          </template>
          <template #cell(actions)="{ item }">
            <actions
              :view_show="false"
              :item="item"
              @delete="deleteAssinatura(item)"
              @edit="editAssinatura(item)"
            />
          </template>
          <template #empty>
            <h5 class="text-center">Nenhum item encontado</h5>
          </template>
        </b-table>
        <hr class="my-5" />
        <h5 class="h5 text-uppercase tracking-widest text-gray pb-2">
          Pagamentos
        </h5>
        <table-history
          :items="cliente_pagamentos"
          hidden-header
          class="border-0"
        />
      </b-card>
      <base-alert
        v-else-if="cliente.parceiro_id"
        type="info"
        class="m-4 p-4 text-center"
      >
        <span class="alert-inner--icon mr-2">
          <font-awesome-icon icon="fas fa-exclamation-triangle" />
        </span>
        <span class="alert-inner--text">
          <strong>Atenção!</strong><br />
          Para visualizar as informações do parceiro é necessário salvar as
          informações do cliente!
        </span>
      </base-alert>
    </div>
    <div v-else>
      <base-alert type="info" class="m-4 p-4 text-center">
        <span class="alert-inner--icon mr-2">
          <font-awesome-icon icon="fas fa-exclamation-triangle" />
        </span>
        <span class="alert-inner--text">
          <strong>Atenção!</strong><br />
          Para visualizar os Pagamentos do Cliente é necessário, primeiro,
          salvar as informações!
        </span>
      </base-alert>
    </div>
    <b-modal
      v-model="modalOpened"
      centered
      size="lg"
      body-class="pt-1"
      ok-title="Salvar"
      cancel-title="Fechar"
      :title="titleModal"
      :hide-footer="showAlert"
      @ok.prevent="submitAssinatura"
    >
      <base-alert
        v-if="showAlert"
        type="neutral"
        class="text-warning text-center py-5"
      >
        <font-awesome-icon icon="fa-exclamation-triangle" />
        Existe um plano ativo, para adicionar um novo plano o plano atual deve
        ser encerrado.
      </base-alert>
      <FormAssinatura v-else ref="form" v-model="formAssinatura" />
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SelectParceiro from "@/modules/parceiros/Components/SelectParceiro.vue";
import format_date from "@/helpers/filters/format_date";
import FormAssinatura from "@/modules/clientes/Components/FormAssinatura.vue";
import cloneDeep from "lodash/cloneDeep";
import safeArray from "lodash/toArray";
import debounce from "lodash/debounce";
import Actions from "@/components/Table/Actions.vue";
import moment from "moment";
import TableHistory from "@/modules/pedidos/Components/TableHistory.vue";

export default {
  components: {
    SelectParceiro,
    FormAssinatura,
    TableHistory,
    Actions,
  },
  data: () => ({
    termo_pesquisa: "",
    user_text: "",
    partners: [],
    mostrarResultados: false,
    editParter: false,
    modalOpened: false,
    formAssinatura: {
      teste_gratis: null,
      plano_exitos_id: null,
      ingresso_at: null,
      expira_at: null,
    },
    indexEdit: null,
    action: "",
  }),
  computed: {
    ...mapState("clientes", [
      "cliente",
      "cliente_pagamentos",
      "pagination_pagamentos",
      "clientesByText",
    ]),
    headers() {
      return [
        {
          key: "plano_exitos.nome",
          label: "Plano",
          class: "col-4",
        },
        {
          key: "ingresso_at",
          label: "Data da Assinatura",
          class: "col-3 text-center",
          formatter: (value) => format_date(value),
        },
        {
          key: "expira_at",
          label: "Data de Vencimento",
          class: "col-3 text-center",
          formatter: (value) => (value ? format_date(value) : ""),
        },
        {
          key: "status",
          label: "Ativo",
          class: "col-2 text-center",
          formatter: (value, _key, item) => {
            if (!!item.id) return value ? "check-circle" : "";
            if (!item.expira_at) return "check-circle";

            return moment(item.expira_at).isSameOrAfter(moment(), "D")
              ? "check-circle"
              : "";
          },
        },
        {
          key: "actions",
          label: "",
          class: "col-1",
        },
      ];
    },
    isFoundPartner() {
      return !this.showPagamentosTable && this.cliente.parceiro_id;
    },
    showPagamentosTable() {
      return this.cliente;
    },
    titleModal() {
      return this.formAssinatura.id ? "Editar Assinatura" : "Nova Assinatura";
    },
    clientePlanos() {
      return safeArray(this.cliente.clientePlanos).map((plano, index) => ({
        _index: index,
        ...plano,
      }));
    },
    existsActivePlan() {
      return this.clientePlanos.some((plano) =>
        plano.expira_at
          ? moment(plano.expira_at).isSameOrAfter(moment(), "D")
          : true
      );
    },
    showAlert() {
      return this.indexEdit === null && this.existsActivePlan;
    },
    clientId() {
      return this.cliente.id;
    },
  },
  methods: {
    ...mapActions("clientes", [
      "ActionGetClientesPagamentos",
      "ActionGetClientesByText",
      "ActionLinkToPartner",
      "ActionAddAssinatura",
      "ActionUpdateAssinatura",
      "ActionRemoveAssinatura",
      "ActionResetClientPagamentos",
    ]),

    resetFormAssinatura() {
      const emptyForm = () => ({
        cliente_id: null,
        plano_exitos_id: null,
        ingresso_at: null,
        expira_at: null,
        _index: null,
      });

      this.indexEdit = null;
      this.formAssinatura = emptyForm();
    },
    deleteAssinatura(item) {
      const index = this.getIndexItem(item);
      if (index === -1) return;

      this.ActionRemoveAssinatura(index);
    },

    novaAssinatura() {
      this.modalOpened = true;
      this.action = "new";
      this.resetFormAssinatura();

      this.formAssinatura.cliente_id = this.cliente.id;
    },
    getIndexItem(item) {
      const findById = (item) => (plano) => plano._index === item._index;
      return this.clientePlanos.findIndex(findById(item));
    },
    editAssinatura(item) {
      this.resetFormAssinatura();
      this.action = "edit";

      this.indexEdit = this.getIndexItem(item);
      this.formAssinatura = cloneDeep(item);
      this.modalOpened = true;
    },

    updateAssinatura(data) {
      const index = this.indexEdit;

      if (index === -1) return;

      const payload = {
        index,
        data,
      };

      this.ActionUpdateAssinatura(payload);
    },

    submitAssinatura() {
      try {
        if (!this.$refs.form.isValid()) return;

        const result = cloneDeep(this.formAssinatura);
        this.modalOpened = false;

        const deboundedFN = debounce(() => {
          if (this.action === "edit") this.updateAssinatura(result);
          if (this.action === "new") this.ActionAddAssinatura(result);
          this.$notifications.addNotification({
            message: "É necessário salvar as alterações",
            icon: "circle-exclamation",
            type: "info",
          });
        }, 500);

        deboundedFN();
      } catch (error) {}
    },

    async buscarClientes() {
      let data = await this.ActionGetClientesByText(this.user_text);
      this.partners = data;
      this.mostrarResultados = true;
    },

    async linkPartner(partner, client) {
      let data = {
        parceiro_id: partner,
        cliente_id: client,
      };
      let req = await this.ActionLinkToPartner(data);
      if (req && !req.error) {
        this.$notifications.addNotification({
          message: "Cliente vinculado com sucesso",
          icon: "exclamation-triangle",
          type: "success",
        });

        this.cliente.parceiro = req;
      }
      this.mostrarResultados = null;
      this.editParter = false;
      this.partners = [];
    },

    async loadData() {
      try {
        const id = this.cliente.id;
        await this.ActionGetClientesPagamentos({
          client_id: id,
          q: this.termo_pesquisa,
          page: this.pagination_pagamentos.current_page,
          per_page: this.pagination_pagamentos.per_page,
        });
      } catch (error) {
        console.log("error", error);
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    debouncedCall: debounce(function () {
      this.loadData();
    }, 250),
  },
  watch: {
    clientId(clientId) {
      this.ActionResetClientPagamentos();
      if (clientId) this.debouncedCall();
    },
  },
};
</script>

<style>
.def-btn {
  height: 20px;
  padding: 0px;
  text-align: center;
}
</style>
